import { normalizeStaffListResponse } from "./useAdminPaginatedQuery"

export const STAFF_MAX_PAGE_SIZE = 100

/**
 * Load every page of a staff list (the API caps page_size at 100) for views
 * that merge or filter rows client-side. Stops at `maxRows` and says so via
 * `truncated`, so callers can warn instead of silently dropping rows.
 */
export async function fetchAllStaffPages(
  fetchFn,
  params = {},
  { pageSize = STAFF_MAX_PAGE_SIZE, maxRows = 2000, concurrency = 4 } = {}
) {
  const first = normalizeStaffListResponse(
    (await fetchFn({ ...params, page: 1, page_size: pageSize })).data
  )
  const total = first.count
  const limit = Math.min(total, maxRows)
  const pageCount = Math.ceil(limit / pageSize)
  const rows = [...first.results]

  for (let page = 2; page <= pageCount; page += concurrency) {
    const batch = []
    for (let p = page; p < page + concurrency && p <= pageCount; p += 1) {
      batch.push(fetchFn({ ...params, page: p, page_size: pageSize }))
    }
    const responses = await Promise.all(batch)
    responses.forEach((response) => {
      rows.push(...normalizeStaffListResponse(response.data).results)
    })
  }

  return {
    rows: rows.slice(0, limit),
    total,
    truncated: total > limit,
  }
}
